/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          : NonMSAConfigureDetails.tsx
*
* Project Title : Checkout
*
* Description   : Initial version
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : H422336
*
* @Date         : Sep 14, 2020
*
* @Version      : Version 1.0
*
* By            : H422336
* On            : Sep 29, 2020
* Description   : ASDS - 3233 UI Enhancements for Phase - II
*
******************************************************************************/
import * as React from 'react';
import '@scuf/common/honeywell/theme.css';
import { connect } from 'react-redux';
import './ConfigureAPU.css';
import { Card, Grid } from '@scuf/common';
import ConfigureAPUActions from '../redux/actions/configure-apu-actions';
import CheckoutConstants from '../constants/checkout-constants';
import NonMSACustomerPO from './NonMSACustomerPO';
import NonMSACustomerKeys from './NonMSACustomerKeys';
import NonMSAServiceOrder from './NonMSAServiceOrder';

interface IConfigureDetailsProps {
    productId: string;
    customerOrderType: string;
}

class NonMSAConfigureDetails extends React.Component<IConfigureDetailsProps> {
    constructor(props) {
        super(props);
    }

    selectedConfigurationForm() {
        let form;

        if (this.props.customerOrderType === CheckoutConstants.NON_MSA_HW_OPTION_CUSTOMER_PO) {
            form = <NonMSACustomerPO productId={this.props.productId} />;
        } else if (this.props.customerOrderType === CheckoutConstants.NON_MSA_HW_OPTION_CUSTOMER_SO) {
            form = <NonMSAServiceOrder />;
        } else {
            form = <NonMSACustomerKeys productId={this.props.productId} />;
        }
        return form;
    }

    render() {
        const configurationForm = this.selectedConfigurationForm();

        return (
            <div className="hardware-options-panel">
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={12}>
                            <Card>
                                <Card.Content>
                                    {configurationForm}
                                </Card.Content>
                            </Card>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}

const mapDispatchToProps = {
    gotoNextTabAPU: ConfigureAPUActions.gotoNextTabAPU
};

function mapStateToProps(state: any) {
    return {
        customerOrderType: state.configAPUData.payload.customerOrderType
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(NonMSAConfigureDetails);